// @flow

// TODO
// atomic化されてないので一旦styledとして別出し
// リファクタリングする場合はatomicなパーツを使うようにしてください

import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMax } from 'components/styles/_media'

export const Container = styled.div`
  width: 800px;
  padding: 56px;
  ${mediaMax.desktop`
    width: 100%;
    padding: 56px 12px;
  `};
`
export const Title = styled.h2`
  margin-bottom: 12px;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.3;
  text-align: center;
  ${mediaMax.desktop`
    font-size: 20px;
  `};
`
export const Description = styled.p`
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  text-align: center;
  ${mediaMax.desktop`
    text-align: left;
  `};
`
export const Head = styled.div`
  margin-bottom: 32px;
`
export const Line = styled.div`
  border-top: 1px solid ${Colors.grayE};
`
export const ContactListItemContainer = styled.div`
  display: block;
`
export const TwoColumn = styled.div`
  display: inline-block;
  float: left;
  width: 100%;
  ${mediaMax.desktop`
    float: none;
  `};
`
export const ThreeColumn = TwoColumn.extend``

export const ContactListItem = styled.li`
  padding: 24px 0;
  border-bottom: 1px solid ${Colors.grayE};

  &[data-type-width='halfWidth'] {
    ${TwoColumn} {
      /* stylelint-disable-line */
      width: 50%;
      padding: 0 10px;
      ${mediaMax.desktop`
        width: 100%;
        padding: 0;
      `} &:not(:first-of-type) {
        ${mediaMax.desktop`
          margin-top: 16px;
        `};
      }
    }

    ${ThreeColumn} {
      /* stylelint-disable-line */
      width: 33%;
      padding: 0 10px;
      ${mediaMax.desktop`
        width: 100%;
        padding: 0;
      `} &:not(:first-of-type) {
        ${mediaMax.desktop`
          margin-top: 16px;
        `};
      }
    }

    ${ContactListItemContainer} {
      margin: 0 -10px;
      ${mediaMax.desktop`
        margin: 0;
      `};
    }
  }
`
export const Column = styled.div`
  text-align: center;
`
export const FormTitle = styled.h3`
  display: table;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  ${mediaMax.desktop`
    margin-bottom: 12px;
  `};
`
export const FormTypeWrapper = styled.span`
  margin-right: 8px;
`
export const FormType = styled.span`
  display: table-cell;
  padding: 4px;
  color: ${Colors.white};
  font-size: 12px;
  background-color: ${Colors.grayB};
  border-radius: 3px;
  vertical-align: middle;

  &[data-type='required'] {
    background-color: ${Colors.red};
  }
`
export const FormTitleText = styled.span`
  display: table-cell;
  color: ${Colors.black};
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  vertical-align: middle;
`
export const SelectWrapper = styled.div`
  position: relative;
  line-height: 0;

  &::before {
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translate(-50%, 0);
    margin-top: -3px;
    font-family: FontAwesome;
    color: ${Colors.blue};
    content: '\f0dd';
    z-index: 1;
  }
`
export const Select = styled.select`
  position: relative;
  height: 32px;
  padding: 8px;
  width: 100%;
  color: ${Colors.black};
  font-size: 14px;
  line-height: 12px;
  border: 1px solid ${Colors.grayD};
  border-radius: 0;
  background-color: transparent;
  appearance: none;
  cursor: pointer;
`
export const CapacityInput = styled.input`
  display: inline-block;
  width: 50%;
  appearance: none;
  border: 1px solid ${Colors.grayD};

  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
`
export const CapacityInputText = styled.span`
  display: inline-block;
  margin-left: 8px;
  color: #999;
  font-size: 14px;
`
export const CapacityInputWrapper = styled.div`
  display: inline-block;
  width: 50%;
  height: 33px;

  &:not(:first-of-type) {
    padding-left: 6px;
    ${mediaMax.desktop`
    padding-left: 0;
    margin-top: 12px;
  `};
  }
`
export const SliderInput = styled.input`
  appearance: none;
  width: 125px;
  color: ${Colors.black};
  border: 1px solid ${Colors.grayD};
  ${mediaMax.desktop`
    width: 50%;
  `} &[type="number"]::-webkit-outer-spin-button,
  &[type="number"]::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  &::placeholder {
    color: #999;
  }
`
export const SliderInputText = styled.span`
  margin-left: 8px;
  color: #999;
  font-size: 14px;
`
export const TextFieldWrapper = styled.div`
  position: relative;
  padding-top: 2px;
  height: 33px;
`
export const Textarea = styled.textarea`
  width: 100%;
  max-width: 684px;
  height: 140px;
  margin-top: 12px;
  padding: 16px;
  color: ${Colors.black};
  font-size: 14px;
  line-height: 1.5714;
  border: 1px solid #d0d1cf;
  ${mediaMax.desktop`
    max-width: none;
    padding: 8px;
    font-size: 13px;
  `} &::placeholder {
    color: #999;
  }
`
export const CheckboxContainer = styled.div`
  display: inline-block;
`
export const SendButtonWrapper = styled.div`
  margin-top: 24px;
  text-align: center;
`
export const SendButton = styled.input`
  display: inline-block;
  width: 200px;
  padding: 16px;
  color: ${Colors.white};
  font-size: 14px;
  font-weight: bold;
  background-color: ${Colors.blue};
  border-bottom: 1px solid ${Colors.blueBdColor};
  border-radius: 3px;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: ${Colors.blueBdColor};
  }
`
export const FormDescription = styled.p`
  font-size: 14px;
  line-height: 1.3;
  color: ${Colors.black};
  ${mediaMax.desktop`
    font-size: 13px;
  `};
`
export const FormDescriptionEm = styled.a`
  display: inline-block;
  color: ${Colors.blue};
  font-size: 14px;
  line-height: 1.714;
`
export const CheckInOnClickWrapper = styled.div`
  position: absolute;
  top: 100%;
  background-color: ${Colors.white};
  box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.2);
  z-index: 1;

  &[data-type-width='fullWidth'] {
    width: 100%;
  }
`
export const CheckInOnClickSpace = styled.div`
  padding: 24px;
`
export const CheckInOnClickButtonWrap = styled.div`
  margin-top: 24px;
  text-align: right;
`
export const CheckInOnClickButton = styled.a`
  font-size: 14px;
  color: ${Colors.black};
  border: none;
  cursor: pointer;

  &:not(:first-of-type) {
    margin-left: 16px;
  }

  &[data-button-type='active'] {
    color: ${Colors.blue};
  }
`



// WEBPACK FOOTER //
// ./src/components/organisms/room/InquiryModal/styled.js